import { connect } from '@cian/adfox-component';

import { OwnTemplates } from './components/OwnTemplates';

export const AdfoxBanner = connect(OwnTemplates);
